import { render, staticRenderFns } from "./roleUserAssign.vue?vue&type=template&id=297f2ee6&scoped=true&"
import script from "./roleUserAssign.vue?vue&type=script&lang=js&"
export * from "./roleUserAssign.vue?vue&type=script&lang=js&"
import style0 from "./roleUserAssign.vue?vue&type=style&index=0&id=297f2ee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297f2ee6",
  null
  
)

export default component.exports